import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { NoData } from "pro-features/components/NoData/src/NoData";
import { SearchTextBox } from "app/pages/sales-intelligence/common-components/SearchTextBox";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledListTabsContainer = styled.div`
    display: flex;
    width: 100%;
    background: ${colorsPalettes.carbon[0]};
    margin-top: 24px;
    .react-tabs {
        width: 100%;
    }
`;

export const StyledHeaderListContainer = styled(FlexRow)`
    justify-content: space-between;
    margin: 10px 8px 10px 16px;
`;

export const StyledSearchTextBox = styled(SearchTextBox)`
    display: flex;

    & > div {
        flex-grow: 1;
    }
`;

export const StyledNoData = styled(NoData)`
    display: flex;
    margin: 72px 0;
`;

export const StyledListContainerWrapper = styled(FlexColumn)`
    padding: 0 8px;
`;
